// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2AR6g","label":"Radio_label__izURg","checkMark":"Radio_checkMark__25D4_","disabled":"Radio_disabled__31qTG"};